<template>
  <div class="content">
    <div
      class="m-header"
      :style="{
        height: pxOrVw(extraItem.extras('nav.model')),
        display: extraItem.extras('nav.display') == 1 ? 'block' : 'none',
      }"
    >
      <div class="header-inner">
        <a
          class="logo"
          href="javascript:;"
          :class="extraItem.extras('logo.size')"
          :style="{
            display: extraItem.extras('logo.display') == 1 ? 'block' : 'none',
          }"
        >
          <img :src="extraItem.extras('logo.src')" alt="" />
        </a>
      </div>
    </div>
    <div
      class="banner"
      :style="{
        display: extraItem.extras('banner.display') == 1 ? 'block' : 'none',
      }"
    >
      <img
        :src="
          extraItem.extras('banner.src')
            ? extraItem.extras('banner.src')
            : imgUrlObj[platform]['banner']
        "
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: ["extras", "platform"],
  data() {
    return {
      imgUrlObj: {
        pc: {
          logo: require("@/assets/images/pc/logo.png"),
          banner: require("@/assets/images/pc/banner.png"),
        },
        wap: {
          logo: require("@/assets/images/wap/logo.png"),
          banner: require("@/assets/images/wap/banner.png"),
        },
      },
    };
  },
};
</script>
